export const switchParagraphFormat = (text: string): string => {
	let paragraphTranslated = text;
	paragraphTranslated = paragraphTranslated.replace("{b}", "");
	paragraphTranslated = paragraphTranslated.replace("{/b}", "");
	return paragraphTranslated;
};
